<template>
  <div>
    <!-- header -->
    <HeaderComponent :headerTitle="headerText" class="header-fixed" :router-link="{ name: 'rfDisposition' }" :router-link-text="'back'"  :return-condition="true" />
    <!-- loader -->
    <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage" :color="primary_code"></loading>
    <!-- content -->
    <v-container fluid grid-list-lg v-if="!isLoading" class="px-0">
      <div class="d-flex justify-center p-4">
        <h3 class="pr-5">Quantity - 
          <span>
            {{ totalQuantity ? totalQuantity : 0 }}
          </span>
        </h3>
        <h3 class="pr-5">Warehouse Ageing - <span>{{averageAgeingTotal ? averageAgeingTotal : 0}} days</span></h3>
        <h3 class="pr-5">Total Values - 
          <span>
            {{ totalValuesCount ? formatToMillion(totalValuesCount) : '₹ 0' }}
          </span>
        </h3>
      </div>
        <v-col cols="12" class="ma-0" xs12>
          <v-row align="center" justify="center" class="mt-0">
            <!-- capital assets -->
            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('Capital Assets') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card m-0" :elevation="10" v-if="inv_status_count">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'CapitalAssets' }"  :class="{ 'disabled-span' : checkDisability('Capital Assets') }">
                      <v-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td class="text-left" style="border:none">
                                <h4 justify="center" class="fw-600">Capital Assets</h4>
                              </td>
                              <td class="text-right" colspan="2" style="border:none">
                                <v-icon>mdi-chevron-right</v-icon>
                              </td>
                            </tr>
                            
                            <tr class="ma-1 pa-1 overflow-hidden text-left border-0" >
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">Quantity - <span>0</span></h3>
                              </td>
                              <td class="text-left border-0">
                                <h3 class="low-alert">Bucket Ageing - <span>0</span></h3>
                              </td>
                            </tr>
                            <tr  class="ma-1 pa-1 overflow-hidden text-left border-0">
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">₹ Value - 
                                 <span>0
                                  </span>
                                </h3>
                              </td>
                            </tr>                            
                          </tbody>
                        </template>
                      </v-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <!-- demo module -->
            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('Demo') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card m-0" :elevation="10" v-if="inv_status_count">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'Demo' }"  :class="{ 'disabled-span' : checkDisability('Demo') }">
                      <v-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              
                              <td class="text-left" style="border:none">
                                <h4 justify="center" class="fw-600">Demo</h4>
                              </td>
                              <td class="text-right" colspan="2" style="border:none">
                                <v-icon>mdi-chevron-right</v-icon>
                              </td>
                            </tr>
                            
                            <tr class="ma-1 pa-1 overflow-hidden text-left border-0">
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">Quantity - <span>0</span></h3>
                              </td>
                              <td class="text-left border-0">
                                <h3 class="low-alert">Bucket Ageing - <span>0</span></h3>
                              </td>
                            </tr>
                            <tr class="ma-1 pa-1 overflow-hidden text-left border-0">
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">₹ Value - 
                                 <span>0
                                  </span>
                                </h3>
                              </td>
                            </tr>                            
                          </tbody>
                        </template>
                      </v-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <!-- replacement -->
            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('Replacement') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card m-0" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'ReplacementForward'}" :class="{ 'disabled-span' : checkDisability('Replacement Forward') }">
                      <v-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td class="text-left" style="border:none">
                                <h4 justify="center" class="fw-600">Replacement</h4>
                              </td>
                              <td class="text-right" colspan="2" style="border:none">
                                <v-icon>mdi-chevron-right</v-icon>
                              </td>
                            </tr>

                            <tr class="ma-1 pa-1 overflow-hidden text-left border-0" >
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">Quantity - <span>0</span></h3>
                              </td>
                              <td class="text-left border-0">
                                <h3 class="low-alert">Bucket Ageing - <span>0</span></h3>
                              </td>
                            </tr>
                            <tr class="ma-1 pa-1 overflow-hidden text-left border-0">
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">₹ Value - 
                                <span>0
                                  </span>
                                </h3>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <!-- rental -->
            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('Rental') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card m-0" :elevation="10" v-if="inv_status_count">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'Rental' }" :class="{ 'disabled-span' : checkDisability('Rental') }">
                      <v-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td class="text-left" style="border:none">
                                <h4 justify="center" class="fw-600">Rental</h4>
                              </td>
                              <td class="text-right" colspan="2" style="border:none">
                                <v-icon>mdi-chevron-right</v-icon>
                              </td>
                            </tr>
                            
                            <tr class="ma-1 pa-1 overflow-hidden text-left border-0" >
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">Quantity - <span>0</span></h3>
                              </td>
                              <td class="text-left border-0">
                                <h3 class="low-alert">Bucket Ageing - <span>0</span></h3>
                              </td>
                            </tr>
                            <tr class="ma-1 pa-1 overflow-hidden text-left border-0">
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">₹ Value - 
                                 <span>0
                                  </span>
                                </h3>
                              </td>
                            </tr>                            
                          </tbody>
                        </template>
                      </v-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <!-- saleable -->
            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('E-Waste') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card m-0" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'Saleable'}" :class="{ 'disabled-span' : checkDisability('Saleable') }">
                      <v-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td class="text-left" style="border:none">
                                <h4 justify="center" class="fw-600">Saleable</h4>
                              </td>
                              <td class="text-right" colspan="2" style="border:none">
                                <v-icon>mdi-chevron-right</v-icon>
                              </td>
                            </tr>
                           
                            <tr class="ma-1 pa-1 overflow-hidden text-left border-0" >
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">Quantity - <span>0</span></h3>
                              </td>
                              <td class="text-left border-0">
                                <h3 class="low-alert">Bucket Ageing - <span>0</span></h3>
                              </td>
                            </tr>
                            <tr class="ma-1 pa-1 overflow-hidden text-left border-0">
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">₹ Value - 
                                 <span>0
                                  </span>
                                </h3>
                              </td>
                            </tr>                            
                          </tbody>
                        </template>
                      </v-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <!-- Production -->
            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card m-0" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'Production'}" :class="{ 'disabled-span' : checkDisability('Production') }">
                      <v-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td class="text-left" style="border:none">
                                <h4 justify="center" class="fw-600">Production</h4>
                              </td>
                              <td class="text-right" colspan="2" style="border:none">
                                <v-icon>mdi-chevron-right</v-icon>
                              </td>
                            </tr>

                            <tr class="ma-1 pa-1 overflow-hidden text-left border-0" >
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">Quantity - <span>0</span></h3>
                              </td>
                              
                              <td class="text-left border-0">
                                <h3 class="low-alert">Bucket Ageing - <span>0</span></h3>
                              </td>
                            </tr>
                            <tr class="ma-1 pa-1 overflow-hidden text-left border-0">
                              <td class="ma-3 pa-3 border-0">
                                <h3 class="high-alert">₹ Value - 
                                 <span>0
                                  </span>
                                </h3>
                              </td>
                            </tr>                            
                          </tbody>
                        </template>
                      </v-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
    </v-container>
  </div>
</template>
<script>
  import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
  import { mapState } from "vuex";
  import Loading from 'vue-loading-overlay';
  // import 'vue-loading-overlay/dist/vue-loading.css';
  import 'vue-loading-overlay/dist/css/index.css';
  import { moduleAccessFunc } from '@/backend/axios/moduleAccess';

  export default {
    data() {
      return {
        headerText: "Forward Disposition",
        data_count:'',
        inv_status_count:'',
        isLoading : false,
        primary_code: "#0275d8",
        fullPage : true,
        totalQuantity: '',
        totalValuesCount:'',
        totalAgeingInDays:'',
        averageAgeingTotal:''
      };
    },
    computed: mapState(["currentUser", "signedIn"]),
    created() {
      this.isLoading = true;
      this.getDispositionCount();
      this.get_Inventory_Status_Count();
    },
    components: {
      HeaderComponent,Loading
    },

    methods: {
      getDispositionCount() {
        this.$httpSecured
          .get("/api/v1/warehouse/inventories/disposition_criticality_count")
          .then((response) => {
            this.data_count = response.data;
            console.log(response.data)
          })
          .catch((error) => {
            this.isLoading = false;
            this.$toast.error("Error in geting disposition count");
          });
      },
      get_Inventory_Status_Count() {
        this.$httpSecured
          .get("/api/v1/warehouse/inventories/inventory_status_count")
          .then((response) => {
            this.inv_status_count = response.data;
            // if(Object.keys(response.data).length){
            this.isLoading = false;
            // }
            console.log(response.data)
          })
          .catch((error) => {
            this.isLoading = false;
            this.$toast.error("Error in geting inventory status count");
          });
      },
      getCount(obj, keys) {
          let current = obj;

          for (const key of keys) {
            if (current && current.hasOwnProperty(key)) {
              current = current[key];
            } else {
              return 0; // Key not found
            }
          }

          return current;
      },
      checkDisability(module){
        const role = this.$store.state.currentUser.roles[0]
        return moduleAccessFunc(role,module)
      },
      formatToMillion(value) {
        const million = value / 1000000; // Convert to millions
        return million.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 }) + 'M';
      },
    },
  };
</script>
<style scoped>
  .v-card-100 { max-width: 100% !important; }

  .fw-600 {
    font-weight: 600 !important;
  }
  .text-color { color: #0357d0; }
  .td-border { border: 2px solid #e5e5e5; }
  .v-data-table__wrapper { overflow-x: inherit !important; overflow-y: inherit !important; }
  .high-alert { color: #A2A3B4; font-size: 12px; font-weight: 600; }
  .medium-alert { color: #A2A3B4; font-size: 12px; font-weight: 600; }
  .low-alert { color: #A2A3B4; font-size: 12px; font-weight: 600;  }
  .high-alert span, .medium-alert span, .low-alert span {
    color: #000000;
  }
  .main_wraper { float: left; width: 100%; position: relative; padding-left: 120px; }
  .v-data-table { height: auto !important; border-radius: 12px; }
  .header-fixed { position: sticky; top: 0; z-index: 999;}
  .rounded-card { box-shadow: none !important;}
  @media (min-width: 1600px){
    .container--fluid{
      max-width: 70%;
    }
  }
  .disabled-span{
    pointer-events: none; 
    opacity: 0.5;
    color: gray;
  }
</style>
